import { ApplicationConfig, DEFAULT_CURRENCY_CODE, provideZoneChangeDetection } from '@angular/core';
import { InMemoryScrollingOptions, provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { BASE_URL_TOKEN } from './core/injection-tokens/base-url.token';
import { environment } from '../environments/environment';
import { MessageService } from 'primeng/api';
import { authInterceptor, errorHandlerInterceptor, refreshTokenInterceptor } from './core/interceptors';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { PUSHER_TOKEN } from './core/injection-tokens/pusher-config.token';
import { provideNgxStripe } from 'ngx-stripe';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'disabled',
};

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling(scrollConfig), withComponentInputBinding()),
    provideClientHydration(withHttpTransferCacheOptions({
      includePostRequests: true
    })),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        errorHandlerInterceptor,
        refreshTokenInterceptor,
      ]),
    ),
    provideAnimations(),
    { provide: DEFAULT_CURRENCY_CODE, useValue: '$' },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'dd/MM/yyyy, hh:mm a' } },
    { provide: BASE_URL_TOKEN, useValue: environment.apiUrl },
    { provide: PUSHER_TOKEN, useValue: environment.pusher },
    provideNgxStripe()
  ]
};
